class exports.Layer_Shapefile_Upload_Confirm_Fields extends DialogHandler
    init: () ->
        @layoutSelector = null
        @layoutUrl = 'backend/grower/layers/shapefile/field_confirmation'
        @defaultSave = false
        @refreshNavHandler = false

        @createDialog()

    afterLoadLayout: () ->
        @openDialog()

